import { navigateToAjs } from './navigator';
import { UPGRADED_ROUTES } from '../config';
import { environment } from '../../environments/environment';
import { UpgradeModule } from "@angular/upgrade/static";
import { resolveUrl } from "@app/core/resolve-url";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgZone } from "@angular/core";
import { CanDeactivateGuard } from "@app/services";
import { SettingsService } from "@app/core";

var pathToNav;
var apiHost = environment.apiHost;

export class HybridFactory {
    static navigate: (path: string, params?: Object) => void = navigateToAjs;
    static getEnvironment(): Object {
        return JSON.parse(JSON.stringify(environment));
    }

    //***************************************************************************
    //                    ANGULAR UPGRADE FUNCTIONS
    //***************************************************************************
    static ngUpgrade: UpgradeModule;

    static isUpgraded(url: string): boolean {
        let presentInUpgradedList = UPGRADED_ROUTES.find(pathPattern => {
            return (new RegExp(pathPattern, 'g')).test(url);
        });
        return !!presentInUpgradedList;
    }

    static routeContainerCleanedUp: boolean = false;

  static urlSwitchedDueToVersion: boolean = false;

  static popstate: string;

    static previousState: {
        name: string;
        url: string;
        params: Object;
    };

    static transitState: {
        name: string;
        url: string;
    };

    // Get AngularJs state from url
    static getState($state, url, queryParams): { state: any; params: Object } {
        let match = $state.get().find((state: any) => {
            if (!state.name || state.abstract || !state.$$state) return false;

            let privatePortion = state.$$state();

            if (!privatePortion.url) return false;

            return privatePortion.url.exec(url, queryParams);

        });

        return match ? { state: match, params: match.$$state().url.exec(url, queryParams) } : null;
    }
    static redirectMicroFrontendRoute(path) {
        const redirectEvent = new CustomEvent('navigate-in-element', {
            detail: {path}
        });
        dispatchEvent(redirectEvent);
    }

    static redirectNg7Route(route: string) {
        let router = HybridFactory.ngUpgrade.injector.get(Router),
            location = HybridFactory.ngUpgrade.injector.get(Location),
            $state = HybridFactory.ngUpgrade.$injector.get('$state'),
            ngZone = HybridFactory.ngUpgrade.injector.get(NgZone);
        let url = resolveUrl(route),
            path = location.normalize(url.pathname);
        ngZone.run(() => {
            $state.go('loggedin.empty');
            HybridFactory.routeContainerCleanedUp = true;
            router.navigateByUrl(path + url.search + url.hash)
        });
    }

    // AngularJs location change start hook
    static onLocationChangeStart(event, next, full) {

        let router = HybridFactory.ngUpgrade.injector.get(Router),
            location = HybridFactory.ngUpgrade.injector.get(Location),
            ngZone = HybridFactory.ngUpgrade.injector.get(NgZone),
            $state = HybridFactory.ngUpgrade.$injector.get('$state');

        let url = resolveUrl(next),
            path = location.normalize(url.pathname),
            isUpgraded = HybridFactory.isUpgraded(decodeURIComponent(path));

        const $rootScope =  HybridFactory.ngUpgrade.$injector.get('$rootScope');
        // console.log('onLocationChangeStart', $rootScope.csNewUiVersion, path);
        let redirectUrl = HybridFactory.shouldRedirect(path, $rootScope.csNewUiVersion);
        if(redirectUrl) {
            event.preventDefault();
            if(redirectUrl.startsWith('loggedin')) {
                $state.go(redirectUrl);
            }
            else {
                ngZone.run(() => router.navigateByUrl(redirectUrl)).then(r => r);
            }
            return;
        }

        // This is if we get this from statechange for switching to a new/old UI views
        if (HybridFactory.urlSwitchedDueToVersion) {
            HybridFactory.urlSwitchedDueToVersion = false;
            event.preventDefault();
            pathToNav = resolveUrl(full).pathname;
            HybridFactory.transitState = {
                name: $state.current.name,
                url: $state.href($state.current.name)
            };
            $state.go('loggedin.empty');
            return;
        }

        // if ('clientsconfig' in event.targetScope.accessDetails &&
        //     'NewPropertyView' in event.targetScope.accessDetails.clientsconfig) {
            let regex = new RegExp("^/customers/(customer|customer_list|work_address)/(\\d+)/view/property/view");
            if (regex.test(path)) {

              let groupings = regex.exec(path);
              ngZone.run(() => router.navigateByUrl('/customers/' + groupings[1] + '/' + groupings[2] + '/view_v2/property/view'));

              HybridFactory.urlSwitchedDueToVersion = true;
              event.preventDefault();
              return;

            }
        // }

        if ('clientsconfig' in event.targetScope.accessDetails && 'NewJobView' in event.targetScope.accessDetails.clientsconfig) {
            // Do NOT redirect jobs_v2/.../costs/view -> parts/view here; allow direct navigation to costs view
            // (refresh, or clicking "Costs" tab). Redirect to parts only when coming from PO save - see onStateChangeStart.

            const regex1 = new RegExp('^/customers/(customer|customer_list|work_address)/(\\d+)/(jobs|job)/(\\d+)/(details|certificates|notes|reminders|files|invoices|costs|additional_works|invoice_items)/(view|jobcostsview)');
            const regex2 = new RegExp('^/customers/(customer|customer_list|work_address)/(\\d+)/(jobs|job)/(\\d+)/(view_parts|office_task|opportunities)');
            const groupings = regex1.exec(path) || regex2.exec(path);
            const jobLinkMap = {
                details: '/details/view',
                office_task: '/details/view',
                view_parts: '/parts/view',
                certificates: '/certificates/view',
                notes: '/details/view',
                reminders: '/details/view',
                files: '/files/view',
                invoices: '/invoices/view',
                costs: '/costs/view',
                additional_works: '/opportunities/view',
                invoice_items: '/costs/view',
                opportunities: '/opportunities/view'
            };
            if (event.targetScope.accessDetails.clientsconfig.NewJobView == 1 && groupings && groupings[5] && jobLinkMap[groupings[5]]) {
                    // Old URL .../jobs/.../costs/jobcostsview -> redirect to jobs_v2/.../parts/view (not costs/view)
                const pathSegment = (groupings[5] === 'costs' || groupings[5] === 'invoice_items') ? '/parts/view' : jobLinkMap[groupings[5]];
                const newJobUrl = `/customers/${groupings[1]}/${groupings[2]}/jobs_v2/${groupings[4]}${pathSegment}`;
                ngZone.run(() => router.navigateByUrl(newJobUrl));

                HybridFactory.urlSwitchedDueToVersion = true;
                event.preventDefault();
                return;
            }
        }

        let pathName = window.location.pathname;
        localStorage.setItem('redirectTo', pathName);

       if ((next == apiHost + "/system_settings" || next == apiHost + "/company_settings" || next.includes('_settings#'))) {
          let pathName = window.location.pathname;
            if (pathName.includes('purchase_trackers')) {
                pathName = '/company_settings/purchase_trackers';
            }
            if( localStorage.getItem('redirectTo') != "/settings" && localStorage.getItem('redirectTo') != "" ) {
                localStorage.setItem('redirectTo', pathName);
            }
            navigateToAjs('/settings?prevSetting=' + pathName);
       } else {
           if( next.includes('settings#') ) {

                let pathName = window.location.pathname;
                //console.log("<--->"+pathName);
                navigateToAjs('/settings?prevSetting=' + pathName);
                if( localStorage.getItem('redirectTo') != "/settings" && localStorage.getItem('redirectTo') != "" ) {
                    localStorage.setItem('redirectTo', pathName);
                }
                //router.navigateByUrl('/settings?prevSetting=' + pathName);
                event.preventDefault();
                //return;
           }
       }


        if (HybridFactory.popstate || (isUpgraded && HybridFactory.routeContainerCleanedUp)) {
            event.preventDefault();
        }
        // Preventing repeated navigation on, ng2 to ng redirection
        else if (!HybridFactory.popstate && !isUpgraded && pathToNav == path && $state.current.name !== 'loggedin.empty') {
            event.preventDefault();
        }

        // Preventing navigation for the unsaved changes warning confirmation in any angular7 component
        HybridFactory.checkForNavigationConfirmation(event, url.pathname + url.hash);

        pathToNav = path;

        // Avoid AngularJs navigation for AngularES routes
        if (!event.defaultPrevented) {
            ngZone.run(() => router.navigateByUrl(path + url.search + url.hash));
        }

        // Handle popstate events
        else if (HybridFactory.popstate) {

            let popstateIsUpgraded = HybridFactory.isUpgraded(HybridFactory.popstate),
                popstate = resolveUrl(HybridFactory.popstate);

            pathToNav = popstate.pathname;

            // Fill up the AngularJs ui-view, While getting back to the ng-ng2 transition state
            if (
                !popstateIsUpgraded
                && $state.current.name == "loggedin.empty"
                && HybridFactory.transitState
            ) {

                let toState = HybridFactory.getState($state,
                    HybridFactory.transitState.url == popstate.pathname ? HybridFactory.transitState.url : popstate.pathname, {});

                if (toState) $state.go(toState.state.name, toState.params);

                HybridFactory.routeContainerCleanedUp = false;
                HybridFactory.transitState = null;

            }

            // Transit AngularJs state with respect to the location
            else if (!popstateIsUpgraded && $state.current.name !== "loggedin.empty") {

                let matchedState = HybridFactory.getState($state, popstate.pathname, {});
                if (matchedState) $state.go(matchedState.state.name, matchedState.params);

            }
            // Clean up AngularJs ui-view, While ng-ng2 popstate transition
            else if (!HybridFactory.routeContainerCleanedUp && popstateIsUpgraded) {

                HybridFactory.transitState = {
                    name: $state.current.name,
                    url: $state.href($state.current.name)
                };
                $state.go('loggedin.empty');
                HybridFactory.routeContainerCleanedUp = true;
            }

        }

        HybridFactory.popstate = null;
    }

    static onStateChangeStart(event, toRoute, toParams, fromRoute, fromParams) {
        let router = HybridFactory.ngUpgrade.injector.get(Router),
            location = HybridFactory.ngUpgrade.injector.get(Location),
            ngZone = HybridFactory.ngUpgrade.injector.get(NgZone),
            $state = HybridFactory.ngUpgrade.$injector.get('$state');

        // if ('clientsconfig' in event.targetScope.accessDetails &&
        //     'NewPropertyView' in event.targetScope.accessDetails.clientsconfig) {
            if (toRoute.name == 'loggedin.customer_list.view.property') {

              ngZone.run(() => router.navigateByUrl('/customers/'+toParams['type']+'/' + toParams['id'] + '/view_v2/property/view'));

              HybridFactory.urlSwitchedDueToVersion = true;
              event.preventDefault();
              return;

            }
        // }

        if ('clientsconfig' in event.targetScope.accessDetails && 'NewJobView' in event.targetScope.accessDetails.clientsconfig) {
            if (event.targetScope.accessDetails.clientsconfig.NewJobView == 1 && (toRoute.name == 'loggedin.customer_list.view.job.details' || toRoute.name == 'loggedin.customer_list.view.job.invoices' || toRoute.name == 'loggedin.customer_list.view.job.viewcost')) {
                if(toRoute.name == 'loggedin.customer_list.view.job.invoices'){
                    ngZone.run(() => router.navigateByUrl('/customers/' + toParams['type'] + '/' + toParams['id'] + '/jobs_v2/' + toParams['jobId'] + '/invoices/view'));
                } else if(toRoute.name == 'loggedin.customer_list.view.job.viewcost'){
                 if(event.targetScope.accessDetails.clientsconfig.NewJobViewScreen == 'Invoices'){
                     ngZone.run(() => router.navigateByUrl('/customers/' + toParams['type'] + '/' + toParams['id'] + '/jobs_v2/' + toParams['jobId'] + '/invoices/view'));
                 }else{
                     // After PO save: parts PO -> parts/view; cost PO or view PO -> costs/view; default -> costs/view
                     const fromPartsPoState = fromRoute && fromRoute.name && (
                         fromRoute.name.indexOf('new_job_part_purchase_order') !== -1 ||
                         fromRoute.name.indexOf('view_purchase_order') !== -1
                     );
                     const viewPath = fromPartsPoState ? '/parts/view' : '/costs/view';
                     ngZone.run(() => router.navigateByUrl('/customers/' + toParams['type'] + '/' + toParams['id'] + '/jobs_v2/' + toParams['jobId'] + viewPath));
                 }
                }else {
                    ngZone.run(() => router.navigateByUrl('/customers/' + toParams['type'] + '/' + toParams['id'] + '/jobs_v2/' + toParams['jobId'] + '/details/view'));
                }
                HybridFactory.urlSwitchedDueToVersion = true;
                event.preventDefault();
                return;
            }
        }

      HybridFactory.checkForNavigationConfirmation(event, toRoute.url);
  }

    // AngularJs location change success hook
    static onLocationChangeSuccess(event, caller: 'NG' | 'NG2', rootScope) {
        let $state = HybridFactory.ngUpgrade.$injector.get('$state'),
            settingsService = HybridFactory.ngUpgrade.$injector.get('NgSettingsService'),
            isUpgraded = HybridFactory.isUpgraded(decodeURIComponent(pathToNav));

        const $rootScope =  HybridFactory.ngUpgrade.$injector.get('$rootScope');
        /*new change start - screen overlap issue */
        /*new change start - screen overlap issue */
        const subscription =  HybridFactory.ngUpgrade.ngZone.onMicrotaskEmpty.subscribe(() => {
            if ($rootScope.$$phase && ($rootScope.$$phase === "$apply" || $rootScope.$$phase === "$digest") ) {
                $rootScope.$$phase = null;
                //console.trace('My-trace');
                return $rootScope.$evalAsync();
            }
            // return $rootScope.$digest();
        });
        $rootScope.$on('$destroy', () => { subscription.unsubscribe(); });
        /*new change end*/

        if (isUpgraded && (
            caller == 'NG2'
            || $state.current.name == "" // This is to prevent show mobile device warning on page refresh
        )) {
            // Route back to AngularJS pages if its bookmarked

            if (!HybridFactory.routeContainerCleanedUp) {
                HybridFactory.transitState = {
                    name: $state.current.name,
                    url: $state.href($state.current.name)
                };
                $state.go('loggedin.empty');
            } else {
                // Update active tab for angularES navigation
                if (event.url && rootScope) {
                    let tabValue = event.url.split('/');
                    if (tabValue[1] != null && tabValue[1] != '') {
                        rootScope.selectedTab = tabValue[1];
                    }
                }
            }
            HybridFactory.routeContainerCleanedUp = true;
        } else HybridFactory.routeContainerCleanedUp = false;
    }

    // AngularJs state change success hook
    static onStateChangeSuccess(toRoute, toParams, fromRoute, fromParams) {
        HybridFactory.previousState = {
            name: fromRoute.name,
            url: fromRoute.url,
            params: fromParams
        };
    }

    static checkForNavigationConfirmation(event, url: string) {
        if (!event.defaultPrevented && CanDeactivateGuard.confirmationCallback) {
            CanDeactivateGuard.invoke(url);
            if (!CanDeactivateGuard.invokeResult) event.preventDefault();
        }
    }
    // ***************************************************************************

    static shouldRedirect(currentUrl: string, newUi: boolean): string {
        const normalize = (url: string) => url.replace(/\/+$/, "");
        const cleanUrl = normalize(currentUrl);

        const a = [
            '/reporting_dashboard',
            '/reporting',
        ];

        // allow new Nav or old Nav
        const b = [
            '/reporting/operational/reporting_operational_list_parts/parts/requested',
            '/reporting/operational/reporting_operational_list_parts/parts/on_order',
            '/reporting/operational/reporting_operational_list_parts/parts/available',
            '/reporting/operational/stock_control/returns_operational_list/excess_for_job',
            '/reporting/operational/stock_control/returns_operational_list/stock_location',
            '/reporting/operational/stock_control/returns_operational_list/supplier',
            '/reporting/operational/reporting_operational_list_parts/incomplete_part_completed_closed_jobs/requested',
            '/reporting/operational/reporting_operational_list_parts/incomplete_part_completed_closed_jobs/on_order',
            '/reporting/operational/reporting_operational_list_parts/incomplete_part_completed_closed_jobs/available',
            '/reporting/view/users/time_sheets/viewSummary',
            '/reporting/view/users/timesheet_approval',
            '/reporting/view/users/daily_timecard',
            '/reporting/view/users/user_list',
            '/reporting/view/users/office_tasks',
            '/reporting/view/users/summary_timesheet/viewSummary',
            '/reporting/view/users/driver_detail'
        ];

        const c = ['/reporting_dashboard_v2'];

        if (!newUi) {
            const isV2 = c.some(path => cleanUrl.startsWith(path));
            return isV2 ? 'loggedin.reporting.dashboard' : '';
        }

        const inA = a.some(path =>
            new RegExp(`^${path}(\\/|$)`).test(cleanUrl)
        );

        const inB = b.some(path => cleanUrl.startsWith(path));
        return inA && !inB ? '/reporting_dashboard_v2' : '';
    }

    static showUserPreferenceToggle(
        betaPropertyName: string,
        screenName: string,
        allowPath: string = '',
        additionalParams: any = {}
    ) {
        if (allowPath === undefined) {
            allowPath = '';
        }
        if (!additionalParams) {
            additionalParams = {};
        }

        const defaultTitle = 'Ready to explore the beta view?';

        const params = {
            NewTopNavUI: {
                title: defaultTitle,
                oldUrl: '/reporting_dashboard',
                newUrl: '/reporting_dashboard_v2/dashboard/default',
            },
            NewJobView: {
                title: defaultTitle,
                oldUrl: additionalParams['oldUrl'],
                newUrl: additionalParams['newUrl'],
            }
        };

        const settingsService =
            HybridFactory.ngUpgrade.$injector.get('NgSettingsService');
        const toggleService =
            HybridFactory.ngUpgrade.$injector.get('NgToggleuserpreferenceService');

        const path = window.location.pathname;

        function hideToggle() {
            toggleService.emit({
                showToggleSwitch: false
            });
        }

        // ---- Route validation ----
        // Only check allowPath restriction for NewTopNavUI screen
        if (screenName === 'NewTopNavUI') {
            if (!allowPath || path.indexOf(allowPath) !== 0) {
                console.log('Hide beta toggle switch');
                hideToggle();
                return;
            }
        }

        // Check if current path matches the NewJobView URL pattern
        // allowPath should contain the regex pattern as a string
        if (screenName === 'NewJobView') {
            const jobViewPattern = new RegExp(allowPath);
            if (!allowPath || !jobViewPattern.test(path)) {
                console.log('Hide beta toggle switch - not on new job view page');
                hideToggle();
                return;
            }
        }

        // ---- Beta validation ----
        const hubSpotBetaStatus = settingsService.getHubSpotBetaStatus();
        if (!hubSpotBetaStatus || !hubSpotBetaStatus[betaPropertyName]) {
            hideToggle();
            return;
        }

        const clientUserPreferences = settingsService.getClientUserPreferences();
        if (!clientUserPreferences) {
            hideToggle();
            return;
        }

        let preferenceValue = false;
        if (clientUserPreferences.hasOwnProperty(screenName)) {
            preferenceValue = !!clientUserPreferences[screenName];
        }

        const screenParams = params[screenName] || {};

        console.log('Show beta toggle switch');
        toggleService.emit({
            betaPropertyName: betaPropertyName,
            showToggleSwitch: true,
            integrationsUI: preferenceValue,
            preferenceValue: preferenceValue,
            screenName: screenName,
            labelName: screenParams.title || defaultTitle,
            oldUrl: screenParams.oldUrl,
            newUrl: screenParams.newUrl,
            dragEnabled: true
        });
    }
}
